<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 引入字体 */
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700&display=swap');

/* 全局样式变量 */
:root {
  /* 主题色彩系统 */
  --primary-color: #3366ff;
  --primary-light: #5c85ff;
  --primary-dark: #0039cb;
  --secondary-color: #5f6caf;
  
  /* 功能性颜色 */
  --success-color: #36b37e;
  --warning-color: #ffab00;
  --danger-color: #ff5630;
  --info-color: #4c9aff;
  
  /* 文本颜色 */
  --heading-color: #172b4d;
  --text-color-primary: #172b4d;
  --text-color-secondary: #6b778c;
  --text-color-disabled: #b3bac5;
  
  /* 背景色 */
  --bg-base: #f8f9fa;
  --bg-light: #ffffff;
  --bg-dark: #eaedf2;
  
  /* 边框颜色 */
  --border-color-base: #e0e0e0;
  --border-color-split: #f0f0f0;
  --border-color-dark: #d9d9d9;
  
  /* 阴影 */
  --box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.08);
  --box-shadow-card: 0 4px 12px rgba(0, 0, 0, 0.05);
  --box-shadow-hover: 0 6px 16px rgba(0, 0, 0, 0.1);
  
  /* 圆角 */
  --border-radius-base: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  
  /* 动画 */
  --transition-base: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  --transition-fast: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  
  /* 特定于项目的变量 */
  --bit-blue: #2d5f8b;
  --bit-light-blue: #4c88b7;
  --bit-dark-blue: #1c405e;
  --component-background: #ffffff;
}

/* 全局基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-color-primary);
  background-color: var(--bg-base);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100%;
}

/* 卡片通用样式 */
.card {
  background-color: var(--bg-light);
  border-radius: var(--border-radius-medium);
  box-shadow: var(--box-shadow-card);
  transition: var(--transition-base);
  overflow: hidden;
  margin-bottom: 20px;
  padding: 20px;
}

.card:hover {
  box-shadow: var(--box-shadow-hover);
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--heading-color);
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-color-split);
}

/* 覆盖Element UI部分样式 */
.el-button--primary {
  background-color: #333;
  border-color: #333;
}

.el-button--primary:hover, .el-button--primary:focus {
  background-color: #555;
  border-color: #555;
}

/* 成功和警告按钮也统一为灰黑色系 */
.el-button--success {
  background-color: #444;
  border-color: #444;
}

.el-button--success:hover, .el-button--success:focus {
  background-color: #666;
  border-color: #666;
}

.el-button--warning {
  background-color: #555;
  border-color: #555;
}

.el-button--warning:hover, .el-button--warning:focus {
  background-color: #777;
  border-color: #777;
}

/* 输入框和按钮高度统一为40px */
.el-input__inner {
  height: 40px !important;
  line-height: 40px !important;
}

.el-button {
  height: 40px !important;
  line-height: 40px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* 其它Element UI样式 */
.el-menu--horizontal > .el-menu-item.is-active {
  color: #333 !important;
  border-bottom-color: transparent !important;
}

.el-menu--horizontal > .el-menu-item {
  height: 64px !important;
  line-height: 64px !important;
}

.el-menu--horizontal.el-menu {
  border-bottom: none !important;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus, 
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  background-color: rgba(0, 0, 0, 0.02) !important;
  color: #333 !important;
}

.el-dropdown-menu {
  border-radius: 6px !important;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 
              0 9px 28px 0 rgba(0, 0, 0, 0.05), 
              0 12px 48px 16px rgba(0, 0, 0, 0.03) !important;
  padding: 8px 0 !important;
}

.el-dropdown-menu__item {
  padding: 12px 20px !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  transition: all 0.3s !important;
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: rgba(0, 0, 0, 0.02) !important;
  color: #333 !important;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #333 !important;
  color: #fff !important;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #333 !important;
}

/* 响应式布局辅助类 */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

@media screen and (max-width: 992px) {
  html, body {
    font-size: 14px;
  }
}

@media screen and (max-width: 768px) {
  html, body {
    font-size: 13px;
  }
  
  .container {
    padding: 0 15px;
  }
}
</style>
